<template>
  <div>
    <LogoImg/>
    <NavBar/>
    <NavMobile/>
    <GradientMap/>
    <MainBanner/>
    <SectionTitle :sectionTitle="what_we_do"
                  :padding="'section-title--full-padding'"/>
    <ColumnsWithIcons/>
    <TextImgComponent :position="'text-img-component--img-right'"
                      :color="'text-img-component--grid-grey'"
                      :bgImg="'text-img-component--img1'"
                      :buttonContent="button_history"/>
    <IconText :buttonContent="button_bottom"/>
    <Footer/>
  </div>
</template>

<script>
import NavBar from './NavBar.vue'
import GradientMap from './GradientMap.vue'
import MainBanner from './MainBanner.vue'
import TextImgComponent from './TextImgComponent.vue'
import SectionTitle from './SectionTitle.vue'
import ColumnsWithIcons from './ColumnsWithIcons.vue'
import LogoImg from './LogoImg.vue'
import IconText from './IconText.vue'
import Footer from './Footer.vue'
import NavMobile from './NavMobile.vue'


export default {
  name: 'PageMain',
  components: {
    NavBar,
    GradientMap,
    MainBanner,
    TextImgComponent,
    SectionTitle,
    ColumnsWithIcons,
    LogoImg,
    IconText,
    Footer,
    NavMobile
  },
  data () {
    return {
      button_history: {
        url: '/o-firmie',
        label: 'DOWIEDZ SIĘ WIECEJ'
      },
      button_bottom: {
        url: '',
        label: ''
      },
      what_we_do: {
        title: 'CZYM SIĘ ZAJMUJEMY'
      }
    }
  }
}
</script>
